export default __webpack_public_path__ + "static/logo-c75ef08ca5a9543c87e8d33d216a4e02.jpeg";